/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'
import { StackPageType } from 'utilities/hooks'

export const NotFoundPage = ({ page, id }: StackPageType) => (
  <div className="not-found-page">
    <div>Not Found</div>
  </div>
)
